import React from "react";
import CustomPopup from "../../../../Common/CustomPopup";
import OutlineButton from "../../../../Common/Buttons/OutlineButton";
import styles from "./index.module.css";
import arrowBlue from "../../../../../assets/images/arrowRightCircle.svg";

const CancelConfirmPopup = ({
  open,
  onClose,
  scheduledDate,
  onConfirmCancel,
  onProceedReschedule,
  loading = false,
}) => {
  return (
    <CustomPopup
      open={open}
      onClose={onClose}
      maxWidth="md"
      className={styles.cancelPopup}
      showCloseButton={true}
      disableBackdropClick={false}
      padding="24px 40px"
      mobilePadding="24px"
    >
      <div className={styles.container}>
        <div className={styles.title}>
          You&rsquo;re about to cancel your trial class scheduled for{" "}
          <span className={styles.highlight}>{scheduledDate}</span>.
        </div>

        <div className={styles.subtitle}>
          Do you want to reschedule the class instead?
        </div>

        <div className={styles.buttonRow}>
          <OutlineButton
            onClick={onConfirmCancel}
            className={styles.cancelClassBtn}
            disabled={loading}
          >
            {loading ? "Cancelling..." : "Cancel my class"}
          </OutlineButton>
          <OutlineButton
            onClick={onProceedReschedule}
            endIcon={<img src={arrowBlue} alt="" width={20} height={20} />}
            className={styles.rescheduleBtn}
            disabled={loading}
          >
            Proceed to reschedule
          </OutlineButton>
        </div>
      </div>
    </CustomPopup>
  );
};

export default CancelConfirmPopup;
